import last from 'lodash/last';

import { getThemeColor } from '../../../utils/theme-utils';

export const dataArrayAsDataSet = (data, label) => ({ data, label });

export const formatSingleLineChart = dataset => ({
  ...dataset,
  borderColor: '#03374E',
  fill: true,
  pointRadius: 0,
})

export const formatSinglePointChart = dataset => ({
  ...dataset,
  borderWidth: 0,
  pointHoverBorderWidth: 2,
  fill: false,
})

export const formatAssayPointDatasets = (datasetOk, datasetAlert) => [
  {
    ...datasetOk,
    borderWidth: 0,
    pointBackgroundColor: '#2EA873',
    pointHoverBorderWidth: 2,
    fill: false,
  },
  {
    ...datasetAlert,
    borderWidth: 0,
    pointBackgroundColor: '#a83e2e',
    pointHoverBorderWidth: 2,
    fill: false,
  }
]

export const formatSequencedBarChartDatasets = (dataset, index, arr) => {
  const isLast = arr?.length === index + 1;

  return {
    ...dataset,
    pointRadius: 0,
    borderColor: isLast ? getThemeColor('chart.window') : getThemeColor('chart.baseline'),
    backgroundColor: isLast ? getThemeColor('faded.window') : getThemeColor('faded.baseline'),
    fill: isLast ? 'origin' : '+1',
  }
}

export const formatSequencedLineChartDatasets = (dataset, index, arr) => {
  const isLast = arr?.length === index + 1;
  const isFirst = index === 0;

  return {
    ...dataset,
    pointRadius: 0,
    borderColor: isFirst ? '#03374E' : isLast ? '#D2080F' : '#E5B50F',
    backgroundColor: isFirst ? '#03374E80' : isLast ? '#D2080F80' : '#E5B50F80',
    fill: isLast ? 'origin' : '+1',
  }
}

export const getThreeDatasetLineChartDatasets = (dataArr1, dataArr2, dataArr3) => [
  {
    label: 'p99 latency',
    data: dataArr1?.map(last),
  },
  {
    label: 'p95 latency',
    data: dataArr2?.map(last),
  },
  {
    label: 'p50 latency',
    data: dataArr3?.map(last),
  },
]

export const getBarChartComparisonDatasets = (baselineData, windowData) => [
  {
    label: 'Baseline',
    data: baselineData,
  },
  {
    label: 'Window',
    data: windowData,
  },
]
